<template>
  <div>
    <CCard>
      <CCardBody>
        <h2>Profile {{ username }}</h2>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'AccountProfile',
  components: {
  },
  computed: {
    username: {
      get() {
        return (this.$api.user && this.$api.user.name) ? this.$api.user.name : ''
      }
    },
  },
}
</script>
